<template>
    <div v-if="pgdata" style="padding-top: 45px;" :style="pgdata.layout">

        <div v-if="pgdata.headinfo"  :style="pgdata.headinfo.layout">

            <div :style="pgdata.headinfo.cont.imglayout">
                <div style="width: 100%;height: 100%;background-size: cover;background-repeat: no-repeat;background-position: top;"
                     :style="{ backgroundImage: 'url(' + pgdata.headinfo.cont.imgurl + ')' }">



                    <div v-if="pgdata.headinfo.cont.titname!=''"
                         :style="pgdata.headinfo.cont.titnamelayout">
                        <div v-html="pgdata.headinfo.cont.titname"> </div>
                    </div>

                    <div v-if="pgdata.headinfo.cont.titsm!=''"
                         :style="pgdata.headinfo.cont.titsmlayout">
                        <div v-html="pgdata.headinfo.cont.titsm"> </div>
                    </div>


                </div>
            </div>


        </div>

        <div v-if="pgdata.contbody" :style="pgdata.contbody.layout">

            asd
        </div>

    </div>
</template>

<script>
    export default {
        name: "conter",
        data(){
            return{
                pgdata:null,
            }
        },
        mounted() {
            const script = document.createElement('script');
            script.src = 'http://example.com/path/to/your/script.js';
            script.onload = () => {
                console.log('Script loaded and ready');
            };
            script.onerror = () => {
                console.error('Error loading script');
            };
            document.head.appendChild(script);
        },
        created() {
            this.pgdata={
                'layout':{

                },
                headinfo:{
                    layout:{width:'100%',position:'relative',},
                    cont:{
                        'titnamelayout':{width:'100%',maxWidth:'1140px', margin:'0 auto',
                            paddingTop:'50px'},
                        'titsmlayout':{width:'100%',maxWidth:'1140px', margin:'0 auto',},
                        'imglayout':{width:'100%',height:'400px'},
                        'titname':'<div style="width: 300px;padding: 10px;font-size: 2rem;color: #ffffff">测试的内容信息</div>',
                        'titsm':'<div style="width: 500px; font-size: .9rem;padding: 10px;font-size: 1rem; color: #fff;">通过专业的培养体系与职业发展体系，激发组织与个人的活力，\n' +
                            '帮助员工与企业共同成长</div>',
                        'imgurl':'https://www.tencent.com/img/banners/brief-1.jpg',
                        'type':'txt',
                        'url':'',
                        'target':'',
                    },
                },
                contbody:{
                    layout:{
                        width:'100%',
                        maxWidth:'1140px',
                        margin:'0 auto',

                    },
                },
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/conter.vue